import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ReservationVisite from './Pages/ReservationVisite';
import ReservationAnniversaire from './Pages/ReservationAnniversaire';
import * as serviceWorker from './serviceWorker';
import ChangementReservationVisite from './Pages/ChangementReservationVisite';
import ReservationGroupes from './Pages/ReservationGroupes';
import ValidationDevisGroupes from './Pages/ValidationDevisGroupes';
import AnnulationDevisGroupes from './Pages/AnnulationDevisGroupes';
import ReservationEvenementSpecial from './Pages/ReservationEvenementSpecial';
import SondageGroupes from './Pages/SondageGroupes';

if (document.getElementById('root')) {
    ReactDOM.render(<App />, document.getElementById('root'));
}
if (document.getElementById('reservation-visite')) {
    ReactDOM.render(<ReservationVisite />, document.getElementById('reservation-visite'));
}
if (document.getElementById('changement-reservation-visite')) {
    ReactDOM.render(<ChangementReservationVisite />, document.getElementById('changement-reservation-visite'));
}
if (document.getElementById('reservation-anniversaire')) {
    ReactDOM.render(<ReservationAnniversaire />, document.getElementById('reservation-anniversaire'));
}
if (document.getElementById('reservation-groupes')) {
    ReactDOM.render(<ReservationGroupes />, document.getElementById('reservation-groupes'));
}
const resaSpecialEventElt = document.getElementById('reservation-evenement-special');
if (resaSpecialEventElt) {
    const category = resaSpecialEventElt.getAttribute('category') || '';
    const evId = resaSpecialEventElt.getAttribute('eventId') || undefined;
    ReactDOM.render(<ReservationEvenementSpecial eventCategoryCode={category} eventId={evId} />, resaSpecialEventElt);
}
if (document.getElementById('validation-devis-groupes')) {
    ReactDOM.render(<ValidationDevisGroupes />, document.getElementById('validation-devis-groupes'));
}
if (document.getElementById('annulation-devis-groupes')) {
    ReactDOM.render(<AnnulationDevisGroupes />, document.getElementById('annulation-devis-groupes'));
}
if (document.getElementById('sondage-groupes')) {
    ReactDOM.render(<SondageGroupes />, document.getElementById('sondage-groupes'));
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
